import { AxiosResponse } from 'axios';
import {
  FanguardApiContractsWatchlistWatchlistDetailModel,
  FanguardApiContractsWatchlistWatchlistSummaryModel,
} from 'src/api/generated';
import { useAppNavigation } from 'src/routes';

import { listsQueries, LISTS_URI } from '@/api/queryKeys';
import { post, put, remove } from '@/api/api';
import { useQuery, UseQueryResult } from '@tanstack/react-query';
import { useMutationWithMessages } from './helpers';

const useGetLists = () => {
  return useQuery(listsQueries.list());
};

const useGetList = (
  id?: string,
): UseQueryResult<AxiosResponse<FanguardApiContractsWatchlistWatchlistSummaryModel>, Error> => {
  return useQuery({
    ...listsQueries.detail(id ?? ''),
    enabled: !!id,
  });
};

const useCreateList = () => {
  return useMutationWithMessages(
    (data: FanguardApiContractsWatchlistWatchlistDetailModel) =>
      post({ uri: LISTS_URI, data: { name: data.name, context: 'accesscontrol' } }),
    {
      entityType: 'list',
      action: 'create',
      queryKeysToInvalidate: [listsQueries.list._def],
    },
  );
};

const useUpdateList = (id?: string) => {
  return useMutationWithMessages(
    (data: FanguardApiContractsWatchlistWatchlistDetailModel) => put({ uri: `${LISTS_URI}/${id}`, data }),
    {
      entityType: 'list',
      action: 'update',
      queryKeysToInvalidate: [listsQueries.list._def, listsQueries.detail(id ?? '').queryKey],
    },
  );
};

const useDeleteList = () => {
  const { navigateTo } = useAppNavigation();

  return useMutationWithMessages((id: string) => remove({ uri: `${LISTS_URI}/${id}` }), {
    entityType: 'list',
    action: 'delete',
    queryKeysToInvalidate: [],
    onSuccess: () => {
      navigateTo.lists();
    },
    customErrorMessage: true,
  });
};

export { useCreateList, useDeleteList, useGetList, useGetLists, useUpdateList };
